<div class="frame">
  <div class="icon">
    <img class="image" [src]="displayLogo(service.logo)" />
  </div>
  <div class="title">
    <div class="heading">{{ service.name }}</div>
    <div class="status">Platform</div>
  </div>
  <div
    *ngIf="isExternalMAMEditor"
    class="cog"
    style="cursor: pointer"
    (click)="editClicked()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M13.0844 9.10436C13.1091 8.90697 13.1276 8.70958 13.1276 8.49986C13.1276 8.29014 13.1091 8.09275 13.0844 7.89537L14.3859 6.87759C14.5031 6.78507 14.534 6.61852 14.46 6.48282L13.2263 4.34858C13.1523 4.21288 12.9857 4.16353 12.85 4.21288L11.3141 4.82971C10.9934 4.58298 10.6479 4.37943 10.2717 4.22522L10.0373 2.59061C10.0188 2.44257 9.88923 2.33154 9.73503 2.33154H7.2677C7.11349 2.33154 6.98396 2.44257 6.96545 2.59061L6.73105 4.22522C6.35479 4.37943 6.00936 4.58915 5.68861 4.82971L4.1527 4.21288C4.01083 4.15737 3.85045 4.21288 3.77643 4.34858L2.54277 6.48282C2.46258 6.61852 2.49959 6.78507 2.61679 6.87759L3.9183 7.89537C3.89363 8.09275 3.87512 8.29631 3.87512 8.49986C3.87512 8.70342 3.89363 8.90697 3.9183 9.10436L2.61679 10.1221C2.49959 10.2147 2.46875 10.3812 2.54277 10.5169L3.77643 12.6511C3.85045 12.7868 4.01699 12.8362 4.1527 12.7868L5.68861 12.17C6.00936 12.4167 6.35479 12.6203 6.73105 12.7745L6.96545 14.4091C6.98396 14.5572 7.11349 14.6682 7.2677 14.6682H9.73503C9.88923 14.6682 10.0188 14.5572 10.0373 14.4091L10.2717 12.7745C10.6479 12.6203 10.9934 12.4106 11.3141 12.17L12.85 12.7868C12.9919 12.8424 13.1523 12.7868 13.2263 12.6511L14.46 10.5169C14.534 10.3812 14.5031 10.2147 14.3859 10.1221L13.0844 9.10436ZM8.50136 10.6588C7.31088 10.6588 6.34245 9.69035 6.34245 8.49986C6.34245 7.30938 7.31088 6.34095 8.50136 6.34095C9.69185 6.34095 10.6603 7.30938 10.6603 8.49986C10.6603 9.69035 9.69185 10.6588 8.50136 10.6588Z"
        fill="black"
        fill-opacity="0.6"
      />
    </svg>
  </div>
</div>
<div class="description">
  <p class="body">
    Name: {{ gateway.name }}<br />
    Created at: {{ gateway.formatCreatedDate() }} <br />
    Operational Status:
    <strong>{{ gateway.isActive ? "Active" : "Deactivated" }}</strong>
  </p>
</div>
<div class="outlined-large" *ngIf="gateway.isActive" (click)="searchClicked()">
  <div class="buttons-medium">OPEN</div>
</div>
